export const ENTITIES_KEY_HUB = 'hubs';
